import React from 'react';
import PropTypes, { InferProps } from 'prop-types';
import Exemption from '../Exemption/Exemption';
import SearchHeader from '../SearchHeader/SearchHeader';

const propTypes = {
  results: PropTypes.array.isRequired,
  searchTerm: PropTypes.string,
  currentPage: PropTypes.number,
  handleChange: PropTypes.func,
  handlePageChange: PropTypes.func,
};

export default function Results(
  props: InferProps<typeof propTypes>,
): JSX.Element {
  const { results, searchTerm, currentPage, handleChange, handlePageChange } =
    props;

  const paginationNumbers = [];
  const resultsPerPage = 10;

  for (let i = 1; i <= Math.ceil(results.length / resultsPerPage); i++) {
    paginationNumbers.push(i);
  }

  const paginatedResults = results.slice(
    (currentPage - 1) * resultsPerPage,
    (currentPage - 1) * resultsPerPage + resultsPerPage,
  );

  return (
    <div>
      <SearchHeader
        count={results.length}
        searchTerm={searchTerm}
        handleChange={handleChange}
      />

      {paginatedResults.map(({ data }, index) => (
        <Exemption
          key={`${index}-${data.exemptionTitle}`}
          title={data.exemptionTitle}
          summary={data.exemptionTitle}
          link={data.pageLink}
          expired={data.expired}
          taxonomies={data.sectors}
        />
      ))}

      {paginationNumbers.length > 1 && (
        <ul className="pagination">
          {paginationNumbers.map((pageNumber) => (
            <li key={`pagination-${pageNumber}`}>
              <button
                className={`pagination__link ${pageNumber == currentPage ? 'current' : ''}`}
                value={pageNumber}
                onClick={handlePageChange}
              >
                {pageNumber}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
